import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateRegisterDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateRegister(
  registerId: string,
  data: UpdateRegisterDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.registers.update(registerId),
    data,
  );
  return response.data;
}
